import React from 'react';
import { Form, Input, Row, Col, Select } from 'antd';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';

const FormItem = Form.Item;
const { Option } = Select;


const defaultProps = {};
const propTypes = {
  intl: intlShape.isRequired,
  countries: PropTypes.array.isRequired,
};


const BIForm = Form.create({
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },
  mapPropsToFields(props) {
    return {
      biName: Form.createFormField(props.biName),
      biAddress: Form.createFormField(props.biAddress),
      biCountry: Form.createFormField(props.biCountry),
      biPhone: Form.createFormField(props.biPhone),
    };
  },
})((props) => {
  const { getFieldDecorator } = props.form;
  const { readOnlyMode, intl } = props;
  const { formatMessage } = intl;
  const requiredError = formatMessage({ id: 'global.errors.inputRequired' });

  return (
    <Form className="normalLabel">
      <Row gutter={24}>
        <Col xs={24} sm={12}>
          <FormItem label="Name" colon={false}>
            {getFieldDecorator('biName', {
              rules: [{ required: true, message: requiredError }],
            })(<Input size="small" className={readOnlyMode ? 'readOnly' : ''} readOnly={readOnlyMode} />)}
          </FormItem>
        </Col>
        <Col xs={24} sm={12}>
          <FormItem label="Address" colon={false}>
            {getFieldDecorator('biAddress', {
              rules: [{ required: true, message: requiredError }],
            })(<Input size="small" className={readOnlyMode ? 'readOnly' : ''} readOnly={readOnlyMode} />)}
          </FormItem>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col xs={24} sm={12}>
          <FormItem label="Country" colon={false}>
            {getFieldDecorator('biCountry', {
              rules: [{ required: true, message: requiredError }],
            })(
              <Select size="small" disabled={readOnlyMode} >
                {props.countries.map(c =>
                  <Option key={c.id} value={c.id}>{c.display_value}</Option>)}
              </Select>
            )}
          </FormItem>
        </Col>
        <Col xs={24} sm={12}>
          <FormItem label="Phone" colon={false}>
            {getFieldDecorator('biPhone', {
              rules: [{ required: true, message: requiredError }],
            })(<Input size="small" className={readOnlyMode ? 'readOnly' : ''} readOnly={readOnlyMode} />)}
          </FormItem>
        </Col>
      </Row>
    </Form>
  );
});


BIForm.defaultProps = defaultProps;
BIForm.propTypes = propTypes;
export default injectIntl(BIForm);



// WEBPACK FOOTER //
// ./src/views/Invoice/components/BillAddress/BIForm.jsx